<template>
  <navbar :title="title" />
  <div class="garage-vehicle-box">
    <van-icon
      key="select-vehicle"
      class="arrow-icon"
      name="arrow-left"
      @click="autoScrollCard('prev')"
    />
    <div class="garage-vehicle-list" ref="tabContainer">
      <div
        :ref="(el) => (tabRefs[index] = el)"
        v-for="(item, index) in allCarList"
        :key="`${item.make}${item.year}`"
        class="vehicle-item"
        :class="active === item.vpid ? 'active' : ''"
        @click="selectTab(index, item)"
      >
        <div name="btn_change_default_vehicle" v-track-click class="vehicle-item-image-box">
          <van-image fit="contain" class="vehicle-item-image" :src="item.image" />
        </div>
        <div class="vehicle-item-row font-size-12">
          <div class="vehicle-item-desc threeLine">
            <span class="mr5">{{ item.year }}</span
            ><span class="mr5">{{ item.make }}</span>
            <br />
            <span>{{ item.model }}</span>
          </div>
        </div>
      </div>
    </div>
    <van-icon
      key="select-vehicle"
      class="arrow-icon"
      name="arrow"
      @click="autoScrollCard('next')"
    />
  </div>
  <div class="pa10">
    <van-button color="#FDBB2B" size="large" @click="handleSelectVehicle">
      {{ $t('message.garage.addNewVehicle') }}
    </van-button>
  </div>
</template>
<script setup>
import navbar from '@/components/navbar/navbar.vue'
import { useGarageStore } from '@/store/garage'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
const router = useRouter()
const garageStore = useGarageStore()
const tabRefs = ref([]) // 存储每个 tab 的 DOM 引用
const tabContainer = ref(null)
const { t } = useI18n()

const title = computed(() => {
  return t('message.garage.selectVehicle')
})

const allCarList = computed(() => garageStore.carList)

const active = ref(0)
const scrollIndex = ref(null)

watch(allCarList, (val) => {
  active.value = val[0].vpid
})

const handleSelectVehicle = () => {
  router.push('/vehiceltype')
}

function scrollTabIntoCenter(tabEl) {
  if (!tabEl || !tabContainer.value) return

  const container = tabContainer.value
  const containerRect = container.getBoundingClientRect()
  const tabRect = tabEl.getBoundingClientRect()
  const offset = tabRect.left - containerRect.left - containerRect.width / 2 + tabRect.width / 2
  container.scrollLeft += offset
}

const autoScrollCard = (type) => {
  if (scrollIndex.value === null) {
    scrollIndex.value = allCarList.value.findIndex((e) => e.vpid === active.value)
  }
  if (type === 'prev' && scrollIndex.value > 0) {
    scrollIndex.value--
  }
  if (type === 'next' && scrollIndex.value < allCarList.value.length) {
    scrollIndex.value++
  }
  scrollTabIntoCenter(tabRefs.value[scrollIndex.value])
}

const selectTab = async (index, item) => {
  await garageStore.doUpdateFavorite({ vpid: item.vpid })
  active.value = item.vpid
  scrollIndex.value = index
  scrollTabIntoCenter(tabRefs.value[index])
  nextTick(() => {
    router.replace('/garage')
  })
}

onMounted(() => {
  if (!allCarList.value || allCarList.value.length === 0) {
    garageStore.getGarageCarList({})
  } else {
    active.value = allCarList.value[0].vpid
  }
})
</script>
<style lang="scss" scoped>
.garage-vehicle-list {
  gap: 10px;
  width: calc(100vw - 48px);
  overflow-x: scroll;
  padding: 10px 0;
  display: flex;
  scroll-behavior: smooth;
  // 隐藏滚动条
  -ms-overflow-style: none; /* IE和Edge */
  scrollbar-width: none; /* Firefox */
  &::-webkit-scrollbar {
    display: none;
  }
  .vehicle-item {
    width: 40vw;
    border-radius: 5px;
    font-size: 14px;
    &.active {
      .vehicle-item-image-box {
        border: 3px solid #fdbb2b;
      }
    }
    .vehicle-item-image-box {
      width: 40vw;
      height: 40vw;
      border: 1px solid #ddd;
      border-radius: 5px;
      .vehicle-item-image {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .vehicle-item-desc {
      color: #333;
    }
    .vehicle-item-row {
      padding: 10px 5px;
    }
  }
  .threeLine {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
}
.garage-vehicle-box {
  display: flex;
  align-items: center;
  .arrow-icon {
    width: 24px;
    font-size: 24px;
  }
}
</style>
